import { addCollection } from '@iconify/vue'

let iconsLoadPromise: Promise<void> | null = null

/** 按需加载并注册本地 sky 图标集，仅加载一次 */
export const ensureIconsLoaded = (): Promise<void> => {
  if (!iconsLoadPromise) {
    iconsLoadPromise = import('@/icons/icons.json').then(m => {
      addCollection(m.default)
    })
  }
  return iconsLoadPromise
}
